import React, { lazy, Suspense } from "react";
import CardProps from "./@types";
import "./card.css";

export default function Card(props: CardProps) {
  const { type, ...other } = props;

  const Component = lazy(
    () =>
      import(`./component/${props.type}`)/* @vite-ignore */
  );
  return (
    <React.Fragment>
      <Suspense fallback={<></>}>
        <Component {...other} />
      </Suspense>
    </React.Fragment>
  );
}
